import { aron, john } from "../../mock";
export var mockGetUsers = {
    users: [john, aron]
};
